export const ONE_TIME_PAYMENT_OPTION_KR = [
  {
    payMethod: 'card',
    pg: 'kcp',
    noticeUrl: `${process.env.REACT_APP_CHECKOUT_BASE_URL}/imp/onetime`,
  },
  {
    payMethod: 'phone',
    pg: 'kcp',
    noticeUrl: `${process.env.REACT_APP_CHECKOUT_BASE_URL}/imp/onetime`,
  },
  {
    payMethod: 'kakaopay',
    pg: 'kcp.IP0WT',
    noticeUrl: `${process.env.REACT_APP_CHECKOUT_BASE_URL}/imp/onetime`,
  },
  {
    payMethod: 'naverpay',
    pg: 'kcp.IP0XK',
    noticeUrl: `${process.env.REACT_APP_CHECKOUT_BASE_URL}/imp/onetime`,
  },
];

export const BILLING_PAYMENT_OPTION_KR = [
  {
    payMethod: 'card',
    pg: 'kcp_billing',
    noticeUrl: `${process.env.REACT_APP_CHECKOUT_BASE_URL}/imp/billing`,
  },
];

/**
 * 카드, 휴대폰 소액 단건 결제
	정기결제 : kcp_billing
	카카오페이 단건 결제
 */
